import axios from "axios";
import AuthService from "./AuthService";
import { getAccessToken } from "./TokenService";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

class Interceptor {
  configure = () => {
    axios.interceptors.request.use((config) => {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
      return config;
    });

    axios.interceptors.response.use(
      (response) => response,

      (error) => {
        const originalRequest = error.config;
        if (
          error.response?.status === 401 &&
          AuthService.hasAccessTokenExpired()
        ) {
          return AuthService.updateToken().then(() => axios(originalRequest));
        }
        if (error.response?.status === 403) {
          return AuthService.handleUserAccess();
        }
        return error;
      }
    );
  };
}

export default new Interceptor();
